<script setup lang="ts">
import {ConversationMessage, type RCSOutboundMessage} from "@/conversation/interfaces";
import {isRCSInbound, isRCSOutbound, isSMSOutbound} from "@/conversation/interfaces/guard";
import type {RcsPayload} from "@/notification-template/interfaces";
import ConversationRCSInboundContent from "@/conversation/components/ConversationRCSInboundContent.vue";
import ConversationMessageBubble from "@/conversation/components/ConversationMessageBubble.vue";
import ConversationSMSContent from "@/conversation/components/ConversationSMSContent.vue";
import ConversationRCSOutboundContent from "@/conversation/components/ConversationRCSOutboundContent.vue";

defineProps<{
    message: ConversationMessage
}>();
</script>

<template>
  <ConversationMessageBubble
    :key="message.id"
    :message="message"
  >
    <ConversationSMSContent
      v-if="isSMSOutbound(message)"
      :payload="message.payload"
    />
    <ConversationRCSOutboundContent
      v-else-if="isRCSOutbound(message)"
      :payload="(message as RCSOutboundMessage).payload as RcsPayload"
      :interactions="message.interactions"
    />
    <ConversationRCSInboundContent
      v-else-if="isRCSInbound(message)"
      :payload="message.payload"
      :replied-to="message.replied_to"
    />
  </ConversationMessageBubble>
</template>

<style scoped>

</style>
